import { convertObjectToSingleString } from '../../../../../utils/helper';
import { LAYOUT_COLUMN, LAYOUT_COLUMN_CONTENT } from '../../../utils/editorStyles.constants';
export const layoutColumn = _ref => {
  let {
    hasInlineStyles
  } = _ref;
  return {
    content: 'block+ layoutSection*',
    isolating: true,
    marks: 'alignment',
    group: 'block',
    attrs: {
      width: {
        default: undefined
      }
    },
    parseDOM: [{
      context: 'layoutColumn//',
      tag: 'div[data-layout-column]',
      skip: true
    }, {
      tag: 'div[data-layout-column]',
      getAttrs: domNode => ({
        width: Number(domNode.getAttribute('data-column-width')) || undefined
      })
    }],
    toDOM(node) {
      let attrs = {
          'data-layout-column': 'true',
          class: 'tap-layout-column'
        },
        contentAttrs = {
          'data-layout-content': 'true',
          class: 'tap-layout-content'
        };
      if (hasInlineStyles) {
        attrs.style = convertObjectToSingleString(LAYOUT_COLUMN);
        contentAttrs.style = convertObjectToSingleString(LAYOUT_COLUMN_CONTENT);
      }
      const {
        width
      } = node.attrs;
      if (width) {
        attrs.style = "".concat(attrs.style ? attrs.style : '', "flex-basis: ").concat(width, "%; max-width: calc(").concat(width, "% - 10px)");
        attrs['data-column-width'] = width;
      }
      // We need to apply a attribute to the inner most child to help
      // ProseMirror identify its boundaries better.
      return ['div', attrs, ['div', contentAttrs, 0]];
    }
  };
};